module.exports = __webpack_public_path__ + "img/swipe-b.79d6fe84.png";